<div class="projects-batch-container">
  <div class="row">
    <div class="col-12">
      <div class="batch-header">
        <div class="initial-description">
          <p><strong>Batch Management:</strong> Create and manage batches of Checklists for organized testing workflows. Select checklists from the left panel, assign a name, and create your batch.</p>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <h5>Available Checklists</h5>
          <div class="header-actions">
            @if (canShowAddToBatchButton()) {
              <button type="button"
                class="btn btn-primary btn-sm"
                (click)="addChecklistsToBatch()">
                <i class="bi bi-plus-lg"></i> Add to Batch
              </button>
            }
            @if (selectedChecklistIds.size > 0 && (!selectedBatchFilter || selectedBatchFilter === 'all')) {
              <button type="button"
                class="btn btn-success btn-sm"
                (click)="openCreateBatchModal()">
                <i class="bi bi-plus-circle"></i> Create Batch
              </button>
            }
          </div>
        </div>
        <div class="card-body">
          <div class="checklists-list">
            @for (checklist of filteredAvailableChecklists; track checklist) {
              <div
                class="checklist-item"
                [class.selected]="(selectedBatchFilter && selectedBatchFilter !== 'all') ? isChecklistForBatchSelected(getChecklistId(checklist)) : isChecklistSelected(getChecklistId(checklist))"
                (click)="(selectedBatchFilter && selectedBatchFilter !== 'all') ? toggleChecklistForBatchSelection(getChecklistId(checklist)) : toggleChecklistSelection(getChecklistId(checklist))">
                <div class="form-check">
                  <input class="form-check-input"
                    type="checkbox"
                    [id]="'checklist-' + getChecklistId(checklist)"
                    [checked]="(selectedBatchFilter && selectedBatchFilter !== 'all') ? isChecklistForBatchSelected(getChecklistId(checklist)) : isChecklistSelected(getChecklistId(checklist))"
                    (click)="$event.stopPropagation()"
                    (change)="(selectedBatchFilter && selectedBatchFilter !== 'all') ? toggleChecklistForBatchSelection(getChecklistId(checklist)) : toggleChecklistSelection(getChecklistId(checklist))">
                  <label class="form-check-label w-100" [for]="'checklist-' + getChecklistId(checklist)" (click)="$event.stopPropagation()">
                    <div class="checklist-name">{{ getChecklistDisplayName(checklist) }}</div>
                    @if (getChecklistDisplayDescription(checklist)) {
                      <div class="checklist-description">
                        {{ getChecklistDisplayDescription(checklist) }}
                      </div>
                    }
                  </label>
                </div>
              </div>
            }

            @if (filteredAvailableChecklists.length === 0) {
              <div class="empty-state">
                <i class="bi bi-inbox"></i>
                <p>No Checklists available</p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <h5>Created Batches</h5>
          @if (batches.length > 0) {
            <div class="batch-filter">
              <select-field
                [selectFormControl]="batchFilterControl"
                [options]="batchFilterOptions"
                (selectionChange)="onBatchFilterChange($event)">
              </select-field>
            </div>
          }
        </div>
        <div class="card-body">
          <div class="batches-list">
            @for (batch of filteredBatches; track batch) {
              <div class="batch-item mb-3">
                <div class="batch-header-section">
                  <div class="batch-info">
                    <h6 class="mb-1">{{ batch.name }}</h6>
                  </div>
                  <div class="batch-actions">
                    <button type="button"
                      class="btn btn-sm btn-outline-primary me-2"
                      (click)="toggleBatchExpansion(batch.projectBatchId)"
                      [title]="isBatchExpanded(batch.projectBatchId) ? 'Hide checklists' : 'Show checklists'">
                      <i class="bi" [class.bi-chevron-down]="!isBatchExpanded(batch.projectBatchId)" [class.bi-chevron-up]="isBatchExpanded(batch.projectBatchId)"></i>
                    </button>
                    <button type="button"
                      class="btn btn-sm btn-outline-danger"
                      (click)="requestDeleteBatch(batch)"
                      title="Delete batch">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
                @if (isBatchExpanded(batch.projectBatchId)) {
                  <div class="batch-checklists mt-2">
                    @for (checklist of batch.checklists; track checklist) {
                      <div class="batch-checklist-item">
                        <div class="checklist-info-compact">
                          <div class="checklist-name-compact">
                            <i class="bi bi-check-square"></i> {{ getChecklistDisplayName(checklist) }}
                          </div>
                        </div>
                        <button type="button"
                          class="btn btn-sm btn-outline-danger"
                          (click)="requestRemoveChecklistFromBatch(batch, checklist)"
                          title="Remove from batch">
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    }
                  </div>
                }
              </div>
            }

            @if (batches.length === 0) {
              <div class="empty-state">
                <i class="bi bi-inbox"></i>
                <p>No batches created yet</p>
                <small class="text-muted">Select Checklists from the left panel to create your first batch</small>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (showCreateBatchModal) {
  <div class="batch-modal-overlay" (click)="closeCreateBatchModal()">
    <div class="batch-modal-dialog" (click)="$event.stopPropagation()">
      <div class="batch-modal-header">
        <div class="header-content">
          <h5>Create New Batch</h5>
          <span class="badge bg-success">{{ selectedChecklistIds.size }} Selected</span>
        </div>
        <button type="button" class="btn-close-custom" (click)="closeCreateBatchModal()" aria-label="Close">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="batch-modal-body">
        <form [formGroup]="batchForm">
          <div class="mb-3">
            <input-field
              [inputFormControl]="getBatchNameControl()"
              label="Batch Name"
              placeholder="Enter batch name">
          </input-field>
        </div>
        <div class="selected-checklists-preview mb-3">
          <h6>Selected Checklists:</h6>
          <ul class="list-unstyled">
            @for (checklist of filteredAvailableChecklists; track checklist) {
              <li class="mb-1">
                @if (isChecklistSelected(getChecklistId(checklist))) {
                  <span>
                    <i class="bi bi-check-circle-fill text-success"></i> {{ getChecklistDisplayName(checklist) }}
                  </span>
                }
              </li>
            }
          </ul>
        </div>
        <div class="d-flex gap-2">
          <button type="button"
            class="btn btn-success flex-fill"
            (click)="createBatchFromModal()"
            [disabled]="batchForm.invalid">
            <i class="bi bi-plus-circle"></i> Create Batch
          </button>
          <button type="button"
            class="btn btn-outline-secondary flex-fill"
            (click)="closeCreateBatchModal()">
            <i class="bi bi-x-circle"></i> Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
